// extracted by mini-css-extract-plugin
export default {"fullScreenPopup":"FullScreenPopup_fullScreenPopup--zWZ","withMenu":"FullScreenPopup_withMenu--a9l","navMenu":"FullScreenPopup_navMenu--DT9"};